import React, { Component } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import ControlTemplate from '~/pages/cp/frontpage'
import DragDropFunctions from '~/utils/TemplateEditor/dragDropFunctions'
export default class ArraySelect extends Component {
    constructor(props) {
        super(props)

        this.state = {
            value: [],
            draggedIndex: null,
            dragging: false,
            dragOverIndex: null,
            insertPosition: 'bottom'
        }
        this.addValue = this.addValue.bind(this)
        this.removeVal = this.removeVal.bind(this)
        this.changeVal = this.changeVal.bind(this)
        this.sortValues = this.sortValues.bind(this)
        this.processIncoming = this.processIncoming.bind(this)
        this.handleDragStart = this.handleDragStart.bind(this)
        this.handleDragOver = this.handleDragOver.bind(this)
        this.handleDragEnter = this.handleDragEnter.bind(this)
        this.handleDragLeave = this.handleDragLeave.bind(this)
        this.handleDrop = this.handleDrop.bind(this)
        this.handleDragEnd = this.handleDragEnd.bind(this)
    }

    componentDidMount() {
        this.processIncoming(this.props)
    }

    componentWillReceiveProps(nextProps) {
        this.processIncoming(nextProps)
    }

    processIncoming(props) {
        var theVal = props.value
        if (theVal && typeof theVal != 'object') {
            if (theVal.indexOf('customField-') > -1) {
                var ourCustomField = JSON.parse(JSON.stringify(DragDropFunctions.customFields))[theVal]
                if (ourCustomField.options && ourCustomField.options.length) {
                    theVal = ourCustomField.options
                } else {
                    theVal = []
                }
            } else {
                theVal = []
            }
            props.updateVal(props.path, theVal)
        }
        this.setState({ value: theVal })
    }
    addValue() {
        var theVals = this.state.value
        theVals.push({ label: '', value: '' })
        this.setState({ value: theVals })
    }

    removeVal(index) {
        var theVals = this.state.value
        theVals.splice(index, 1)
        this.setState({ value: theVals })
        this.props.updateVal(this.props.path, theVals)
    }

    changeVal(event, index) {
        var theVals = this.state.value
        var currVal = theVals[index]
        if (typeof currVal != 'object') currVal = { value: currVal, label: currVal }
        if (event.target.name == 'label') {
            let prevLabel = currVal.label
            currVal.label = event.target.value
            if ((currVal.value == '' || currVal.value == prevLabel) && this.props.valueCantBeBlank) {
                currVal.value = event.target.value
            }
        }
        if (event.target.name == 'value') currVal.value = event.target.value

        theVals[index] = currVal
        this.setState({ value: theVals })
        this.props.updateVal(this.props.path, theVals)
    }

    sortValues() {
        var theVals = this.state.value
        theVals.sort((a, b) => {
            if (a.label < b.label) return -1
            if (a.label > b.label) return 1
            return 0
        })
        this.setState({ value: theVals })
        this.props.updateVal(this.props.path, theVals)
    }

    handleDragStart = (index) => {
        this.setState({
            draggedIndex: index,
            dragging: true
        })
    }
    handleDragOver = (e) => {
        e.preventDefault()
        e.stopPropagation()
        e.dataTransfer.dropEffect = 'move'
    }
    handleDragEnter = (index, e) => {
        if (this.state.draggedIndex !== null && this.state.draggedIndex !== index) {
            const rect = e.currentTarget.getBoundingClientRect()
            const mouseY = e.clientY
            const elementTop = rect.top
            const elementHeight = rect.height
            const elementMiddle = elementTop + elementHeight / 2

            const insertPosition = mouseY < elementMiddle ? 'top' : 'bottom'

            this.setState({
                dragOverIndex: index,
                insertPosition: insertPosition
            })
        }
    }
    handleDragLeave = (e) => {
        const currentTarget = e.currentTarget
        const relatedTarget = e.relatedTarget

        if (!currentTarget.contains(relatedTarget)) {
            this.setState({ dragOverIndex: null })
        }
    }
    handleDrop = (e, dropIndex) => {
        e.preventDefault()
        e.stopPropagation()
        const { draggedIndex, insertPosition } = this.state

        if (draggedIndex === null || draggedIndex === dropIndex) {
            this.setState({
                draggedIndex: null,
                dragging: false,
                dragOverIndex: null,
                insertPosition: 'bottom'
            })
            return
        }

        const theVals = this.state.value
        const draggedItem = theVals[draggedIndex]
        theVals.splice(draggedIndex, 1)
        let insertIndex
        if (insertPosition === 'top') {
            if (draggedIndex < dropIndex) {
                insertIndex = dropIndex - 1
            } else {
                insertIndex = dropIndex
            }
        } else {
            if (draggedIndex < dropIndex) {
                insertIndex = dropIndex
            } else {
                insertIndex = dropIndex + 1
            }
        }
        theVals.splice(insertIndex, 0, draggedItem)

        this.setState({ value: theVals })
        this.props.updateVal(this.props.path, theVals)

        this.setState({
            draggedIndex: null,
            dragging: false,
            dragOverIndex: null,
            insertPosition: 'bottom'
        })
    }
    handleDragEnd = () => {
        this.setState({
            draggedIndex: null,
            dragging: false,
            dragOverIndex: null,
            insertPosition: 'bottom'
        })
    }

    render() {
        var style = {}
        if (this.props.elementData.optionFullWidth) style = { flex: '100%' }

        let title = this.props.title
        if (this.props.elementData.hasOwnProperty('labelNew')) {
            title = this.props.elementData.labelNew
        }

        return (
            <div className='dndEditorv2-dd_toolHolder ' style={style}>
                <div className='dd_inputTool'>
                    {title && <p className='txtInput_label'>{title}</p>}

                    {this.state.value.length > 0 && (
                        <div className='mar-b15'>
                            {this.state.value.map((theVal, index) => {
                                var theValue = ''
                                var theLabel = ''

                                if (typeof theVal == 'object') {
                                    theValue = theVal.value
                                    theLabel = theVal.label
                                } else {
                                    theValue = theVal
                                    theLabel = theVal
                                }

                                let labelTxt = 'Label'
                                let valueTxt = 'Value'

                                if (this.props.fieldLabelTxt) labelTxt = this.props.fieldLabelTxt
                                if (this.props.fieldValueTxt) valueTxt = this.props.fieldValueTxt
                                const isErroredValue = this.props.valueCantBeBlank && theValue == ''

                                let outerStyle = {}
                                if (this.state.dragging && this.state.draggedIndex === index) {
                                    outerStyle.opacity = 0.5
                                }

                                return (
                                    <div
                                        key={'theOpt-' + index}
                                        style={outerStyle}
                                        className='dndEditorv2-dd_subToolOptionHolder'
                                        draggable={true}
                                        onDragStart={(e) => {
                                            e.dataTransfer.effectAllowed = 'move'
                                            e.dataTransfer.setData('text/html', index.toString())
                                            e.stopPropagation()
                                            this.handleDragStart(index)
                                        }}
                                        onDragEnter={(e) => this.handleDragEnter(index, e)}
                                        onDragLeave={(e) => this.handleDragLeave(e)}
                                        onDragOver={(e) => {
                                            e.preventDefault()
                                            e.stopPropagation()
                                            e.dataTransfer.dropEffect = 'move'
                                            this.handleDragEnter(index, e)
                                        }}
                                        onDrop={(e) => {
                                            e.stopPropagation()
                                            this.handleDrop(e, index)
                                        }}
                                        onDragEnd={this.handleDragEnd}
                                    >
                                        <div style={{ flex: 0 }}>
                                            <Icons
                                                icon='drag'
                                                color='#666'
                                                style={{ height: 16, width: 16, cursor: 'move' }}
                                            />
                                        </div>
                                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
                                            <div>
                                                <TextInput
                                                    label={labelTxt}
                                                    type='text'
                                                    value={theLabel}
                                                    name='label'
                                                    placeHolder='Enter a label'
                                                    onChange={(event) => {
                                                        this.changeVal(event, index)
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <TextInput
                                                    label={valueTxt}
                                                    type='text'
                                                    value={theValue}
                                                    name='value'
                                                    placeHolder='Enter a value'
                                                    onChange={(event) => {
                                                        this.changeVal(event, index)
                                                    }}
                                                    style={isErroredValue ? { borderColor: 'red' } : {}}
                                                    error={isErroredValue ? "Value can't be blank" : ''}
                                                />
                                            </div>
                                        </div>
                                        <div style={{ flex: 0 }}>
                                            <Icons
                                                icon='bin'
                                                onClick={(event) => {
                                                    this.removeVal(index)
                                                }}
                                                color='#DD4340'
                                                style={{ height: 16, width: 16 }}
                                            />
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    )}

                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        <Button
                            text='Add Option'
                            onClick={this.addValue}
                            className='button-sml button-primary'
                            iconLeft={<Icons icon='plus' />}
                        />
                        {this.state.value.length > 1 && (
                            <Button text='Sort Values (A-Z)' onClick={this.sortValues} className='button-sml' />
                        )}
                    </div>
                </div>
            </div>
        )
    }
}
